import type { TabDef } from "../types";

interface TabsProps<K extends string> {
  tabs: TabDef<K>[];
  active: K;
  onChange: (key: K) => void;
}

export function Tabs<K extends string>(
  { tabs, active, onChange }: TabsProps<K>,
) {
  return (
    <nav class="tabs" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.key}
          class={"tab" + (active === t.key ? " is-active" : "")}
          role="tab"
          aria-selected={active === t.key ? "true" : "false"}
          onClick={() => onChange(t.key)}
        >
          {t.label}
          {t.count != null && <span class="tab-count">{t.count}</span>}
        </button>
      ))}
    </nav>
  );
}
